import { WebShopMaskFormValue } from './types';

export const WEB_SHOP_REQUEST_DATA: WebShopMaskFormValue = {
  id: null,
  name: null,
  customerNumber: null,
  url: null,
  shopType: null,
  userName: null,
  password: null,
};
